import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { clearFilter } from '../../components/Configuration/Articles/filterConfig'
import apiClient from '../../utils/api/apiClient'
import { APIEndpoints } from '../../utils/api/apiConfig'
import { PenIcon } from '../../components/Icons/PenIcon'
import { BiCopy } from "react-icons/bi";
import { useTranslation } from 'react-i18next'
import axios from 'axios'

const CancelToken = axios.CancelToken;
let cancel;

const ArticlesContext = React.createContext({})
export function useArticlesState() {
  return React.useContext(ArticlesContext)
}

const initialFilter = {
  'filter.number': '',
  'filter.internalName': '',
  'filter.externalName': '',
  'filter.classInternalName': '',
  'filter.classExternalName': '',
  'filter.templateArticles': '',
}

const ArticlesProvider = ({ children }) => {
  const [loaded, setLoaded] = useState(false)
  const [pageOffset, setPageOffset] = useState(0)
  const [pageLimit, setPageLimit] = useState(10)
  const [totalCount, setTotalCount] = useState(0)
  const [showAllArticles, setShowAllArticles] = useState(false)
  const [filter, setFilter] = useState(initialFilter)
  const [sorting, setSorting] = useState('number')
  const [selectedRow, setSelectedRow] = useState(false)
  const [articles, setArticles] = useState([])
  const [tableIsLoading, setTableIsLoading] = useState(false)
  const [showOverlayLeft, setShowOverlayLeft] = useState(false)
  const [filterArticle, setFilterArticle] = useState(null)
  const [forceReloadArticles, setForceReloadArticles] = useState(false)
  const [selectedCheckBoxes, setSelectedCheckBoxes] = useState([])
  const [allCheckBoxesSelected, setAllCheckBoxesSelected] = useState(false)
  const [allSelectedLoading, setAllSelectedLoading] = useState(false)
  const [initialTableId, setInitialTableId] = useState(null)
  const [lastParams, setLastParams] = useState(JSON.stringify({
    pageOffset,
    pageLimit,
    filter,
    showAllArticles,
    sorting
  }))
  const { t } = useTranslation()
  const resetFilter = (test = null) => {
    clearFilter()
    setFilter(initialFilter)
    if (!showAllArticles) {
      setArticles([])
      setTotalCount(0)
    }

  }
  const handleLocalChangeCheckbox = id => {
    if (allCheckBoxesSelected) {
      setAllCheckBoxesSelected(false)
    }
    if (selectedCheckBoxes.includes(id)) {
      var index = selectedCheckBoxes.indexOf(id);
      var newValues = [...selectedCheckBoxes]
      newValues.splice(index, 1);
      setSelectedCheckBoxes(newValues)
    }
    else {
      setSelectedCheckBoxes(prev => [...prev, id])
    }
  }

  //cancel previous calls that are still pending if existing
  const cancelPrevious = () => {
    cancel && cancel()
  }

  const loadArticles = async () => {
    cancelPrevious()
    const cancelToken = new CancelToken(function executor(c) {
      cancel = c;
    })
    try {
      let params = getParams()
      const response = await apiClient.getJson(APIEndpoints.articleAdmin(), params, true, true, true, { cancelToken })
      if (response.headers['x-total-count']) {
        setTotalCount(Number(response.headers['x-total-count']))
      } else { setTotalCount(0) }
      return response.data
    }
    catch (e) {
      if (axios.isCancel(e)) {
        console.log("cancelled by cancelToken")
      }
      return null
    }
  }

  const getParams = () => {
    const filterWithValues = { ...filter }
    Object.keys(filterWithValues).forEach(filterName => {
      if (filterWithValues[filterName] === '') {
        delete filterWithValues[filterName]
      }
    })
    let params = { ...filterWithValues }
    params['page.offset'] = pageOffset
    params['page.limit'] = pageLimit
    if (sorting) {
      params['sort'] = sorting
    }
    return params
  }

  const appendData = (data) => {
    return data.map(item => ({
      ...item, actions: (
        <span>
          {!filter['filter.templateArticles'] &&
            <span>
              <Link to={`/articlesAdministration/editArticle/${item.id}`} onClick={e => { e.stopPropagation() }}
                title={t('employeesPage:editAction')}><PenIcon color="#000000" /></Link>
            </span>}
          <span>
            <Link to={`/articlesAdministration/copyArticle/${item.id}`} onClick={e => { e.stopPropagation() }}
              title={t('officeAdmin:copy')}><BiCopy color="#000000" /></Link>
          </span>
        </span>
      ),
      checkBox: (
        <span>
          <input type="checkbox" id={item.id} name="scales"
            checked={selectedCheckBoxes.includes(item.id)} onChange={() => { }}>
          </input>
        </span>
      )
    }))
  }

  useEffect(() => {
    const newParams = JSON.stringify({ pageOffset, pageLimit, filter, showAllArticles, sorting })
    const filtersHaveChanged = JSON.stringify(filter) !== JSON.stringify(JSON.parse(lastParams).filter)
    const sortingHasChanged = JSON.stringify(sorting) !== JSON.stringify(JSON.parse(lastParams).sorting)
    //go to page 1 if filter or sorting have changed
    if (pageOffset !== 0 && (sortingHasChanged || filtersHaveChanged)) {
      var newParamsFilter = JSON.parse(lastParams)
      newParamsFilter.filter = filter
      newParamsFilter.sorting = sorting
      setLastParams(JSON.stringify(newParamsFilter))
      setPageOffset(0)
    }
    else if (lastParams !== newParams || forceReloadArticles) {
      setForceReloadArticles(false);
      setLastParams(newParams);
      (async () => {
        if (showAllArticles || Object.keys(filter).reduce((acc, item) => (acc || filter[item] !== ''), false)) {
          setTableIsLoading(true)
          const result = await loadArticles()
          if (result) {
            // add action icons
            let preparedResult = appendData(result)
            setArticles(preparedResult)
            setTableIsLoading(false)
          }
        } else {
          cancelPrevious()
          setArticles([])
          setTotalCount(0)
          setTableIsLoading(false)
        }
        if (filtersHaveChanged) {
          //setSelectedCheckBoxes([])
          setAllCheckBoxesSelected(false)
        }
      })()
    }
    //eslint-disable-next-line
  }, [pageOffset, pageLimit, filter, showAllArticles, sorting, forceReloadArticles, setForceReloadArticles])


  const selectAll = () => {
    if (allCheckBoxesSelected || (articles.length < 1)) {
      setAllCheckBoxesSelected(false)
      setSelectedCheckBoxes([])
    }
    else {
      setAllSelectedLoading(true)
      const filterWithValues = { ...filter }
      Object.keys(filterWithValues).forEach(filterName => {
        if (filterWithValues[filterName] === '') {
          delete filterWithValues[filterName]
        }
      })
      apiClient.getJson(APIEndpoints.articleAdmin(), { ...filterWithValues }).then(result => {
        if (result) {
          const arrayOfAllIds = result.map(obj => obj.id)
          setSelectedCheckBoxes(arrayOfAllIds)
        }
      }).finally(() => { setAllCheckBoxesSelected(true); setAllSelectedLoading(false) })
    }
  }


  useEffect(() => {
    // add action icons
    // todo only change selected one

    setArticles(prev => (prev.map(item => ({
      ...item,
      checkBox: (
        <span>
          <input type="checkbox" id={item.id} name="scales"
            checked={selectedCheckBoxes.includes(item.id)} onChange={() => { }}>
          </input>
        </span>
      )
    }))))
  }, [selectedCheckBoxes])


  const contextValues = {
    setSelectedCheckBoxes,
    allCheckBoxesSelected,
    selectAll,
    allSelectedLoading,
    selectedCheckBoxes,
    handleLocalChangeCheckbox,
    loaded,
    setLoaded,
    pageOffset,
    setPageOffset,
    pageLimit,
    setPageLimit,
    totalCount,
    setTotalCount,
    showAllArticles,
    setShowAllArticles,
    filter,
    setFilter,
    articles,
    setArticles,
    selectedRow,
    setSelectedRow,
    sorting,
    setSorting,
    resetFilter,
    tableIsLoading,
    showOverlayLeft,
    setShowOverlayLeft,
    filterArticle,
    setFilterArticle,
    forceReloadArticles,
    setForceReloadArticles,
    initialTableId, setInitialTableId
  }
  return (
    <ArticlesContext.Provider value={contextValues}>
      {children}
    </ArticlesContext.Provider>
  )
}

export default ArticlesProvider
